import { Divider, Grid2, Slider, styled } from '@mui/material';
import { Card } from '../Card/Card';
import { AppTypography } from '../AppTypography/AppTypography';

export const StyledTypography = styled(AppTypography)(({ theme }) => ({
	textAlign: 'left',
	marginBottom: theme.spacing(1),
}));

export const StyledSection = styled(Grid2)(({ theme }) => ({
	marginTop: theme.spacing(2),
	marginBottom: theme.spacing(2),
}));

export const StyledContainer = styled(Grid2)(({ theme }) => ({
	backgroundColor: theme.palette.highlighted.secondary,
	borderRadius: theme.spacing(1),
	border: '1px solid',
	borderColor: theme.palette.borders.primary,
	padding: theme.spacing(2),
}));

export const StyledDivider = styled(Divider)<{ my?: number }>(({ theme, my = 2 }) => ({
	marginTop: theme.spacing(my),
	marginBottom: theme.spacing(my),
}));

export const StyledCard = styled(Card)<{ withBorder?: boolean; paddingX?: number }>(
	({ theme, withBorder, paddingX = 4 }) => ({
		paddingLeft: theme.spacing(paddingX),
		paddingRight: theme.spacing(paddingX),
		...(withBorder && {
			border: '1px solid',
			borderColor: theme.palette.insurance.highlight,
		}),
	})
);

export const StyledPaymentsContainer = styled(Grid2)<{ isMobile?: boolean }>(({ theme, isMobile }) => ({
	...(!isMobile && {
		backgroundColor: theme.palette.highlighted.secondary,
		borderRadius: theme.spacing(1),
		border: '1px solid',
		borderColor: theme.palette.borders.primary,
		padding: theme.spacing(2),
	}),
}));

export const StyledDocumentContainer = styled(Grid2)(({ theme }) => ({
	justifyContent: 'flex-start',
	border: '1px solid',
	borderRadius: theme.spacing(1),
	borderColor: theme.palette.insurance.primary,
	padding: theme.spacing(0, 2),
	[theme.breakpoints.up('md')]: {
		justifyContent: 'center',
		padding: theme.spacing(0.5, 2),
	},
}));

export const StyledDocumentSubContainer = styled(Grid2)(({ theme }) => ({
	alignItems: 'center',
	minHeight: theme.spacing(6),
}));

export const StyledDocumentTypography = styled('p')(({ theme }) => ({
	color: theme.palette.insurance.primary,
	fontSize: '14px',
	maxWidth: '230px',
	textAlign: 'left',
	fontWeight: 'bold',
}));

export const StyledDocumentLink = styled('a')(() => ({
	textDecoration: 'none',
}));

export const Pill = styled('div')<{ required?: boolean }>(({ theme, required }) => ({
	backgroundColor: required ? theme.palette.borders.primary : theme.palette.insurance.primary,
	color: '#fff',
	fontWeight: 700,
	fontSize: '12px',
	padding: '4px 12px',
	borderRadius: '9999px',
	textTransform: 'uppercase',
	display: 'inline-block',
	letterSpacing: '0.5px',
}));

export const StyledSlider = styled(Slider)(({ theme }) => ({
	color: theme.palette.insurance.secondary,
	height: 4,
	marginTop: 16,
	'& .MuiSlider-track': {
		backgroundColor: theme.palette.insurance.secondary,
		border: 'none',
	},
	'& .MuiSlider-rail': {
		backgroundColor: '#ccc',
		opacity: 1,
	},
	'& .MuiSlider-thumb': {
		width: 20,
		height: 20,
		backgroundColor: 'white',
		border: '4px solid',
		borderColor: theme.palette.insurance.secondary,
		boxShadow: 'none',
		'&:hover, &.Mui-focusVisible, &.Mui-active': {
			boxShadow: 'none',
		},
	},
	'& .MuiSlider-mark': {
		backgroundColor: '#ccc',
		height: 15,
		width: 2,
		marginTop: -22,
		borderRadius: 1,
	},
}));
